export default "__VITE_ASSET__Cgih8I9W__"